import React from 'react';

interface IconAcquisitionsProps {
  /** Icon dimensions in pixels (width & height). Defaults to 24. */
  size?: number | string;
  /** Stroke width. Defaults to 2 (matches Tabler default). */
  stroke?: number;
  /** Applies to the SVG `color` / `stroke`. Defaults to `currentColor`. */
  color?: string;
}

/**
 * A transaction / acquisitions icon rendered as an inline SVG so it respects
 * `currentColor` (dark-mode safe) and sizes predictably on all devices.
 *
 * API mirrors `@tabler/icons-react` components.
 */
const IconAcquisitions = ({
  size = 24,
  stroke = 2,
  color = 'currentColor',
}: IconAcquisitionsProps) => {
  const s = typeof size === 'string' ? size : `${size}px`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
    >
      {/* Document outline */}
      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
      <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" />
      {/* Dollar sign */}
      <path d="M9 15c.2.4.6.7 1 .9.5.2 1 .3 1.5.3s1-.1 1.5-.4c.4-.2.7-.6.7-1s-.3-.8-.7-1c-.5-.3-1.1-.4-1.7-.6-.6-.2-1.1-.4-1.5-.7-.4-.3-.7-.7-.7-1.2 0-.5.3-.9.7-1.2.4-.2.9-.4 1.5-.4s1 .1 1.5.4c.4.2.7.5.8.9" />
      <path d="M12 10v-.5" />
      <path d="M12 16.5v-.5" />
    </svg>
  );
};

export default IconAcquisitions;
